import React from "react";
import Dialog from "@material-ui/core/Dialog";
import "bodycodi/cmap/app/css/common/passUsableBranchList.css";

const PassUsableBranchList = ({ open, setOpen, list }) => {
  const closePop = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={closePop} className="alert-pop" classes={{ paper: "alert" }}>
      <BranchList list={list} onClose={closePop} />
    </Dialog>
  );
};

const BranchList = ({ list, onClose }) => {
  const branchList = list.map((branchName, index) => {
    return <div key={index}>{branchName}</div>;
  });

  return (
    <React.Fragment>
      <div className="use-able-partnerbranch-pop-wrap" onClick={onClose}>
        <div className={"use-able-partnerbranch-pop"}>
          <div className="use-able-partnerbranch-header">
            이용 가능한 지점 <span>{list.length}개</span>
          </div>
          <div className="use-able-partnerbranch-body">{branchList}</div>
          <div className="use-able-partnerbranch-footer">
            <button className="btn" onClick={onClose}>
              확인
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PassUsableBranchList;
